import ServerAPI from '../server';
import HolidayBook from '@/apis/books/holiday.json';

const getHolidays = (payload) => {
  return ServerAPI.get(HolidayBook.REST);
};

export { getHolidays };
